export default "/images/plus-ic.svg?4c3ebeefde3e2c2c17f786f7d2f1deae";